/**
 * @generated SignedSource<<8fc743fa44c5cd210e605b4e8ce0cf28>>
 * @relayHash d689c46cc95f36419f19f207f3ceb687
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID da0d02555fb2e7138559c38df00467b0a1669fe42733ebf6cfa8115dbdbb4a2f

import type { ConcreteRequest } from 'relay-runtime';
export type GraphQLContentStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "%future added value";
export type stateResolverPreloadAnnotationsDataQuery$variables = {
  contentStatus?: ReadonlyArray<GraphQLContentStatus | null> | null;
  first: AGG$Long;
  pageId: string;
};
export type stateResolverPreloadAnnotationsDataQuery$data = {
  readonly comments: {
    readonly __typename: "PaginatedCommentList";
    readonly nodes: ReadonlyArray<{
      readonly contentStatus: string;
      readonly id: string;
      readonly location: {
        readonly __typename: string;
        readonly inlineMarkerRef?: string | null;
        readonly inlineResolveProperties?: {
          readonly resolved: boolean;
        } | null;
        readonly type: string;
      };
    } | null> | null;
    readonly totalCount: number | null;
  } | null;
};
export type stateResolverPreloadAnnotationsDataQuery = {
  response: stateResolverPreloadAnnotationsDataQuery$data;
  variables: stateResolverPreloadAnnotationsDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentStatus"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = [
  {
    "args": [
      {
        "kind": "Literal",
        "name": "confluenceCommentFilter",
        "value": {
          "commentState": "UNRESOLVED",
          "commentType": "INLINE"
        }
      },
      {
        "kind": "Variable",
        "name": "contentStatus",
        "variableName": "contentStatus"
      },
      {
        "kind": "Literal",
        "name": "depth",
        "value": "ROOT"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
      },
      {
        "kind": "Literal",
        "name": "type",
        "value": [
          "INLINE"
        ]
      }
    ],
    "concreteType": "PaginatedCommentList",
    "kind": "LinkedField",
    "name": "comments",
    "plural": false,
    "selections": [
      {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "contentStatus"
          },
          {
            "kind": "LinkedField",
            "name": "location",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "type"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "inlineMarkerRef"
                  },
                  {
                    "concreteType": "InlineCommentResolveProperties",
                    "kind": "LinkedField",
                    "name": "inlineResolveProperties",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "resolved"
                      }
                    ]
                  }
                ],
                "type": "InlineComment"
              }
            ]
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "totalCount"
      },
      (v3/*: any*/)
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "stateResolverPreloadAnnotationsDataQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "stateResolverPreloadAnnotationsDataQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "d689c46cc95f36419f19f207f3ceb687",
    "id": "da0d02555fb2e7138559c38df00467b0a1669fe42733ebf6cfa8115dbdbb4a2f",
    "metadata": {},
    "name": "stateResolverPreloadAnnotationsDataQuery",
    "operationKind": "query",
    "text": "query stateResolverPreloadAnnotationsDataQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long!){comments(pageId:$pageId,contentStatus:$contentStatus,confluenceCommentFilter:{commentState:UNRESOLVED,commentType:INLINE},type:[INLINE],depth:ROOT,first:$first){nodes{id,contentStatus,location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved}}}},totalCount,__typename}}"
  }
};
})();

(node as any).hash = "af92d028ec6cef46bb981d53522dfe18";

export default node;
